






















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import BlogDetailModal from '../modals/BlogPostsModal.vue';
import moment from 'moment-timezone';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'blogs',
    data: function () {
        return {
            blogsPage_: 1,
        };
    },
    components: {
        BlogDetailModal,
        Spinner,
    },
    filters: {
        date(val) {
            return val == null ? 'Rango de fecha' : moment(val).format('YYYY/MM/DD');
        },
    },
    computed: {
        ...mapState('blogPosts', ['allBlogs', 'allBlogsLoading', 'blogsPerPage', 'blogsPage', 'blogsTotal']),
        ...mapState('blogPosts', {
            allBlogs: (state: any) => {
                const allBlogs = state.allBlogs.map((blog: any) => {
                    let logistic_type;

                    return {
                        ...blog,
                    };
                });
                // console.log(allBlogs);
                return _.orderBy(allBlogs, 'created_at', 'asc');
            },
        }),
    },
})
export default class Blogs extends Vue {
    public allBlogs!: any;
    public allBlogsLoading!: any;
    public blogsPerPage!: any;
    public blogsPage!: any;
    public blogsTotal!: any;
    private activeBlogLoaded: boolean = false;
    private activeFilters: boolean = false;
    public blogsPage_!: any;
    // public logistic_type_filter: any = '';
    public blog_word_search: any = '';

    allBlogsHeaders = [
        { thClass: 'th', key: 'id', label: 'No. Blog' },
        { thClass: 'th', key: 'title', label: 'Título' },
        // { thClass: "th", key: "tags", label: "Estatus" },
        // { thClass: "th", key: "entry_amount", label: "Ingreso" },
        // { thClass: "th", key: "payment_amount", label: "Saldo" },
        // { thClass: "th", key: "intelisis_movement", label: "Movimiento" },
        // { thClass: "th", key: "comments", label: "Comentarios" },
        { thClass: 'th', key: 'edit', label: '' },
    ];

    public dateRange: any = {
        startDate: null,
        endDate: null,
    };
    singleDatePicker: any = 'range';

    setUrlPage(page: any) {
        this.$router.push({
            path: 'blog-posts',
            query: {
                ...this.$route.query,
                page,
            },
        });
        this.blogsPage_ = page;
    }

    setUrlSort(ctx: any) {
        this.$router.push({
            path: 'blog-posts',
            query: {
                ...this.$route.query,
                sortName: ctx.sortBy,
                sortValue: ctx.sortDesc ? 'desc' : 'asc',
            },
        });
    }

    setUrlSearch(search: string) {
        // @ts-ignore
        // this.clearFilters();
        search = search.trim();
        this.$router.push({
            path: 'blog-posts',
            query: {
                ...this.$route.query,
                search,
            },
        });
    }

    onOpenBlogDetailModal(id: number | null = null) {
        this.$store.dispatch('blogPosts/getOne', id);
        this.activeBlogLoaded = true;
        setTimeout(() => {
            this.$bvModal.show('blog-detail-modal');
        }, 400);
    }

    onEditBlog(id: number) {
        this.$store.dispatch('blogPosts/getOne', id);
        this.activeBlogLoaded = true;
        setTimeout(() => {
            this.$bvModal.show('blog-detail-modal');
        }, 400);
    }

    @Watch('$route')
    getAllBlogs() {
        const page = this.$route.query.page || 1;
        const search = this.$route.query.search || null;
        this.$store.dispatch('blogPosts/getAll', {
            page,
            search,
        });
    }

    mounted() {
        this.getAllBlogs();
        this.blogsPage_ = 1;
    }
}
